import { CategoryListGetResponse } from '../../features/category/model/categoryModel';
import { TagGetResponse } from '../model/commonModel';
import { KeywordGetResponse } from '../../features/keyword/model/keywordModel';

export enum COMMON_TYPES {
  GET_CATEGORIES_LIST = 'GET_CATEGORIES_LIST',
  GET_CATEGORIES_LIST_SUCCESS = 'GET_CATEGORIES_LIST_SUCCESS',
  GET_TAGS_LIST = 'GET_TAGS_LIST',
  GET_TAGS_LIST_SUCCESS = 'GET_TAGS_LIST_SUCCESS',
  GET_KEYWORDS_LIST = 'GET_KEYWORDS_LIST',
  GET_KEYWORDS_LIST_SUCCESS = 'GET_KEYWORDS_LIST_SUCCESS',
}

export interface GetCategoriesListAction {
  type: COMMON_TYPES.GET_CATEGORIES_LIST;
  payload: null;
}

export interface GetCategoriesListSuccessAction {
  type: COMMON_TYPES.GET_CATEGORIES_LIST_SUCCESS;
  payload: {
    categoriesList: CategoryListGetResponse[];
  };
}

export interface GetTagsListAction {
  type: COMMON_TYPES.GET_TAGS_LIST;
  payload: null;
}

export interface GetTagsListSuccessAction {
  type: COMMON_TYPES.GET_TAGS_LIST_SUCCESS;
  payload: {
    tagsList: TagGetResponse[];
  };
}

export interface GetKeywordsListAction {
  type: COMMON_TYPES.GET_KEYWORDS_LIST;
  payload: null;
}

export interface GetKeywordsListSuccessAction {
  type: COMMON_TYPES.GET_KEYWORDS_LIST_SUCCESS;
  payload: {
    keywordsList: KeywordGetResponse[];
  };
}

export type CommonActions =
  | GetCategoriesListAction
  | GetCategoriesListSuccessAction
  | GetTagsListAction
  | GetTagsListSuccessAction
  | GetKeywordsListAction
  | GetKeywordsListSuccessAction;

export interface CommonState {
  categoriesList: CategoryListGetResponse[];
  tagsList: TagGetResponse[];
  keywordsList: KeywordGetResponse[];
}
